function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { cn } from "../../../lib/utils";
import { BUTTON_TYPE_ITEM_OTHER_CLASS, EQUAL_DIVIDED_TAB_ITEM_LINE_HEIGHT, TEXT_TAB_ITEM_CLASS, getButtonTypeColorClass } from "./tabs.constant";
import { jsx as _jsx } from "react/jsx-runtime";
var activeTabBottomLineClass = 'after:bg-brandColor-bds-brand-700-normal after:w-full after:block after:left-0 after:bottom-0 after:h-0.5 after:absolute';
export var renderTabItem = function renderTabItem(_ref) {
  var label = _ref.label,
    size = _ref.size,
    tabStyle = _ref.tabStyle,
    tabClass = _ref.tabClass,
    tabType = _ref.tabType,
    buttonType = _ref.buttonType,
    isEqualDivided = _ref.isEqualDivided,
    singleLineClass = _ref.singleLineClass,
    showActiveBottomLine = _ref.showActiveBottomLine,
    buttonVariants = _ref.buttonVariants,
    isMobile = _ref.isMobile,
    disabled = _ref.disabled;
  var renderDom = {
    title: /*#__PURE__*/_jsx("div", {
      className: cn('h-full relative', 'aria-selected:text-base-bds-gray-t1-title aria-selected:cursor-default', 'data-[disabled]:hover:cursor-not-allowed data-[disabled]:hover:text-base-bds-gray-t4-dis data-[disabled]:text-base-bds-gray-t4-dis', buttonVariants({
        size: size
      }), !isMobile ? 'hover:text-base-bds-gray-t1-title' : '', tabClass, _defineProperty({
        'cursor-pointer': !disabled,
        'flex-1 shrink-0 text-center': isEqualDivided,
        'inline-flex items-center min-w-max': !isEqualDivided
      }, singleLineClass, isEqualDivided), showActiveBottomLine ? activeTabBottomLineClass : ''),
      style: _objectSpread(_objectSpread({}, tabStyle), isEqualDivided ? {
        lineHeight: EQUAL_DIVIDED_TAB_ITEM_LINE_HEIGHT[size]
      } : {}),
      children: label
    }),
    button: /*#__PURE__*/_jsx("div", {
      className: cn('inline-flex items-center h-full min-w-max transition-all aria-selected:cursor-default', 'data-[disabled]:hover:cursor-not-allowed data-[disabled]:hover:text-base-bds-gray-t4-dis data-[disabled]:text-base-bds-gray-t4-dis', {
        'cursor-pointer': !disabled
      }, buttonVariants({
        size: size,
        tabType: tabType
      }), tabClass, BUTTON_TYPE_ITEM_OTHER_CLASS[size], getButtonTypeColorClass({
        buttonType: 'primaryLite',
        tabType: tabType,
        isMobile: isMobile,
        disabled: disabled
      })),
      style: tabStyle,
      children: label
    }),
    buttonBg: /*#__PURE__*/_jsx("div", {
      className: cn('h-full transition-all aria-selected:cursor-default', 'data-[disabled]:hover:cursor-not-allowed data-[disabled]:hover:text-base-bds-gray-t4-dis data-[disabled]:text-base-bds-gray-t4-dis', BUTTON_TYPE_ITEM_OTHER_CLASS[size], getButtonTypeColorClass({
        buttonType: buttonType,
        tabType: tabType,
        isMobile: isMobile,
        disabled: disabled
      }), tabClass, _defineProperty({
        'cursor-pointer': !disabled,
        'flex-1 shrink-0 text-center': isEqualDivided,
        'inline-flex items-center min-w-max': !isEqualDivided
      }, singleLineClass, isEqualDivided)),
      style: _objectSpread(_objectSpread({}, tabStyle), isEqualDivided ? {
        lineHeight: EQUAL_DIVIDED_TAB_ITEM_LINE_HEIGHT[size]
      } : {}),
      children: label
    }),
    text: /*#__PURE__*/_jsx("div", {
      className: cn('min-w-max inline-flex items-center h-full color-base-bds-gray-t2 transition-all aria-selected:cursor-default', 'data-[disabled]:hover:cursor-not-allowed data-[disabled]:hover:text-base-bds-gray-t4-dis data-[disabled]:text-base-bds-gray-t4-dis', {
        'cursor-pointer': !disabled
      }, !isMobile ? 'hover:text-base-bds-gray-t3' : '', TEXT_TAB_ITEM_CLASS[size], tabClass),
      style: tabStyle,
      children: label
    })
  };
  return renderDom[tabType];
};